<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container fluid class="pa-0 ma-0">
    <v-dialog v-model="dialog" max-width="600" persistent scrollable>
      <v-form v-model="valid" lazy-validation ref="form" id="new-form">
        <v-card>
          <v-card-title>
            <span class="headline">{{ dialogTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-select
                    v-model="toBeEdit.clientid"
                    required
                    :items="clients"
                    label="Client"
                  ></v-select>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    v-model="toBeEdit.orderid"
                    required
                    type="number"
                    label="Order ID"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-text-field
                    v-model="toBeEdit.amount"
                    required
                    type="number"
                    label="Amount (USD)"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="toBeEdit.notes"
                    label="Notes (Optional)"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" text @click="dialog = false"
              >Cancel</v-btn
            >
            <v-btn
              color="primary darken-1"
              dark
              form="new-form"
              @click="validate"
              :disabled="!valid"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-row dense>
      <v-sheet class="flex-fill pb-4" color="#f9f9f9" outline elevation="1">
        <v-row class="px-4 pt-4">
          <v-col md="4" sm="12" xs="12" cols="12" class="my-0 py-0">
            <v-autocomplete
              prepend-icon="mdi-account"
              v-model="clientid"
              :items="clients"
              label="Filter by client name ..."
            />
          </v-col>
          <v-col md="4" sm="12" xs="12" cols="12" class="my-0 py-0">
            <v-text-field
              prepend-icon="mdi-magnify"
              v-model="orderid"
              label="Search by order ID ..."
            />
          </v-col>
          <v-spacer></v-spacer>
          <v-col md="2" sm="12" xs="12" cols="12" class="my-0 py-0">
            <v-spacer></v-spacer>
            <v-btn @click="newClicked()" dark color="blue darken-4"
              ><v-icon class="mr-2">mdi-plus</v-icon> New Payment</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-data-table
              :footer-props="{
                'items-per-page-options': [25, 50, 100, 150, -1]
              }"
              :items-per-page="50"
              :search="title"
              :loading="isloading"
              :loading-text="loadingtext"
              :headers="headers"
              :items="items"
              :item-key="item.id"
              :pageCount="numberOfPages"
              :server-items-length="totalItems"
              :options.sync="options"
              ref="tbl"
            >
              <template slot="items" slot-scope="{ item }">
                <td>{{ item.id }}</td>
                <td>{{ item.amount }}</td>
                <td>{{ item.orderid }}</td>
                <td>{{ item.clientid }}</td>
                <td>{{ item.notes }}</td>
                <td>{{ item.addedby }}</td>
                <td>{{ item.addby }}</td>
              </template>

              <template v-slot:item.amount="{ item }">
                <v-chip
                  ><strong>${{ item.amount }}</strong></v-chip
                >
              </template>

              <template v-slot:item.action="{ item }">
                <div
                  class="d-flex align-center align-content-center justify-center"
                >
                  <v-btn
                    class="actionbtns mx-1"
                    primary
                    dark
                    small
                    color="orange"
                    center
                    @click="showSales(item)"
                  >
                    <v-icon medium>
                      mdi-eye
                    </v-icon>
                  </v-btn>

                  <v-btn
                    class="actionbtns mx-1"
                    primary
                    dark
                    small
                    color="orange"
                    center
                    @click="editClicked(item)"
                  >
                    <v-icon medium>
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                  <v-btn
                    class="actionbtns mx-1"
                    color="red"
                    small
                    warning
                    dark
                    @click="deleteItem(item)"
                  >
                    <v-icon medium>
                      mdi-delete
                    </v-icon>
                  </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-sheet>
    </v-row>
  </v-container>
</template>

<script>
import { __HTTP, FormHeader, __HAS_PERM } from "@/utils/utils";

export default {
  name: "Payments",
  computed: {},
  components: {},
  watch: {
    options: {
      handler() {
        this.getList()
      }
    }
  },
  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.insertNewItem();
      }
    },
    newClicked() {
      this.dialogTitle = "New payment";
      this.toBeEdit = {
        orderid: "",
        clientid: "",
        amount: "",
        notes: "",
        isnew: true,
        id: 0
      };
      this.dialog = true;
    },
    editClicked(item) {
      this.dialogTitle = "Edit payment";
      this.toBeEdit = {
        orderid: item.orderid,
        clientid: item.clientid,
        amount: item.amount,
        notes: item.notes,
        isnew: false,
        id: item.id
      };
      this.dialog = true;
    },
    getList() {
      this.items = [];
      this.isloading = true;
       const { page, itemsPerPage } = this.options;
      let pageNumber = page - 1;
      __HTTP(
        "?do=list&type=payments",
        JSON.stringify({ keyword: "" ,
        pageNumber: pageNumber,
          itemsPerPage: itemsPerPage,
        }),
        FormHeader,
        res => {
          //console.log(res);
           this.numberOfPages = res.numOfPages;
          this.totalItems = parseInt(res.items);
          this.isloading = false;
          this.items = res.data;
        }
      );
    },
    getClients() {
      this.loading = true;
      __HTTP("?do=getclients", "", FormHeader, res => {
        this.isloading = false;
        this.clients = res;
      });
    },

    insertNewItem() {
      __HAS_PERM(
        this.toBeEdit.isnew ? 24 : 22,
        this.$store.state.loggedUser.id,
        () => {
          __HTTP(
            "?do=" + (this.toBeEdit.isnew ? "new" : "edit") + "&type=payments",
            JSON.stringify({
              id: this.toBeEdit.id,
              orderid: this.toBeEdit.orderid,
              clientid: this.toBeEdit.clientid,
              amount: this.toBeEdit.amount,
              notes: this.toBeEdit.notes
            }),
            FormHeader,
            res => {
              //console.log(res);

              if (res.auth) {
                var index = this.clients.findIndex(
                  o => o.value == this.toBeEdit.clientid
                );
                // console.log(index);
                //console.log(this.clients[index]);
                if (this.toBeEdit.isnew) {
                  this.items.push({
                    id: res.id,
                    orderid: this.toBeEdit.orderid,
                    clientid: this.clients[index],
                    amount: this.toBeEdit.amount,
                    notes: this.toBeEdit.notes,
                    adddate: res.adddate
                  });
                } else {
                  // let index = this.items.findIndex(o => o.id == this.toBeEdit.clientid);

                  this.items.splice(index, 1, {
                    id: this.toBeEdit.id,
                    orderid: this.toBeEdit.orderid,
                    clientid: this.toBeEdit.clientid,
                    amount: this.toBeEdit.amount,
                    notes: this.toBeEdit.notes
                  });
                }
                this.dialog = false;
              } else {
                /// error
                console.log(res);
                alert("Error with payment!");
              }
            }
          );
        }
      );
    },

    deleteItem(item) {
      const index = this.items.indexOf(item);
      let c = confirm("Are you sure to remove this record ?");
      if (c) {
        __HAS_PERM(23, this.$store.state.loggedUser.id, () => {
          __HTTP("?do=delete", { type: "payments", id: item.id }, null, () => {
            this.items.splice(index, 1);
          });
        });
      }
    }
  },
  created() {
    this.getClients();
    //this.getList();
    this.getClients();
    this.$store.state.title = "Payments";
  },
  data: () => ({
    valid: true,
    search: "",
    options: {},
    numberOfPages:0,
    totalItems: 0,
    isloading: false,
    loadingtext: "Please wait while loading data ...",
    toBeEdit: { amount: "", orderid: "", clientid: "", notes: "", isnew: true },
    headers: [
      {
        sortable: true,
        text: "#",
        value: "id"
      },
      {
        sortable: true,
        text: "Amount",
        value: "amount"
      },
      {
        sortable: true,
        text: "Order ID",
        value: "orderid"
      },
      {
        sortable: true,
        text: "Client",
        value: "clientid.text"
      },
      {
        sortable: true,
        text: "Notes",
        value: "notes"
      },
      {
        sortable: true,
        text: "Added by",
        value: "addby"
      },
      {
        sortable: true,
        text: "Added on",
        value: "adddate"
      },
      { text: "Tools", value: "action", sortable: false }
    ],
    items: [],
    item: [],
    clients: [],
    title: "",
    clientid: "",
    orderid: "",
    dialog: false,
    dialogTitle: "New Payment Record",
    amountRules: [
      v => !!v || "Amount is required",
      v =>
        (v && v.length >= 1) || "Amount must be equal or greater than 1 digit."
    ],
    titleRules: [
      v => !!v || "Title is required",
      v => (v && v.length >= 2) || "Title must be greater than 2 characters"
    ],
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+/.test(v) || "E-mail must be valid"
    ],
    phoneRules: [
      v => !!v || "Phone number is required",
      v => (v && v.length >= 11) || "Phone number must be 11 digits or greater."
    ]
  })
};
</script>
